// src/start/sheet-flag.ts: the board's welcome sheet is for the tab that pressed Send (docs/onsite/ONSITE.md 4.3).
// /start marks the new board in this tab's sessionStorage; the board shows the sheet once and clears the mark. While
// the sheet is on its way or up, the install card waits (src/pwa/prompt.ts): it never sits over the welcome modal.
import { signal } from "@preact/signals";
import { session } from "../lib/storage";

const pendingKey = (pid: string) => `sheet-pending:${pid}`;

/** The welcome sheet is on screen (src/prospect/WelcomeSheet.tsx sets it while open). */
export const welcomeSheetOpen = signal(false);
/** Bumped when a mark is set or cleared, so what reads welcomeSheetUp() follows the marks (sessionStorage is not a signal). */
const marks = signal(0);

export function markWelcomeSheet(pid: string): void {
  session.set(pendingKey(pid), "1");
  marks.value++;
}
export function welcomeSheetPending(pid: string): boolean {
  return session.get(pendingKey(pid)) === "1";
}
export function clearWelcomeSheet(pid: string): void {
  session.remove(pendingKey(pid));
  marks.value++;
}

/**
 * The welcome sheet is up, or on its way: the board at `pid` was opened with `?welcome=1` from the tab that pressed
 * Send (the welcome email's link carries `?welcome=1` too, but no mark, and shows no sheet).
 */
export function welcomeSheetUp(pid: string | undefined, query: URLSearchParams): boolean {
  void marks.value;
  if (welcomeSheetOpen.value) return true;
  return !!pid && query.get("welcome") === "1" && welcomeSheetPending(pid);
}
